// https://vuex.vuejs.org/en/actions.html

export default {
  applyFilter ({ commit }, params) {
    return new Promise((resolve) => {
      commit('applyFilter', params)

      resolve()
    })
  }
}
